<template>
  <div class="news_item">
    <div class="news_img">
      <nuxt-link :to="handleNewsUrl(news.viewUrl, news.newsId)" :title="news.newsName" target="_blank" prefetch-on="interaction">
        <!-- 如果是具体行业的资讯，前四个不懒加载，如果是资讯首页，前两个不懒加载 -->
        <img
          :src="`${news.logo}?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_236,h_138/quality,q_90/watermark,image_bG9nby9qdXpoYW4ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTI,x_10,y_10`"
          :alt="news.newsName" v-if="(showType && currentIndex > 3 ) || (!showType && currentIndex > 1)" loading="lazy" />
        <img
          :src="`${news.logo}?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_236,h_138/quality,q_90/watermark,image_bG9nby9qdXpoYW4ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTI,x_10,y_10`"
          :alt="news.newsName" v-else />
      </nuxt-link>
    </div>
    <div class="news_info">
      <p class="news_title">
        <nuxt-link :to="handleNewsUrl(news.viewUrl, news.newsId)" :title="news.newsName" target="_blank" prefetch-on="interaction">
          {{ news.newsName }}
        </nuxt-link>
      </p>
      <div class="news_abstract">
        {{ description(news) }}
      </div>
      <div class="news_sub">
        <span v-if="$get(news, 'industryId[0]', 0)" class="industry">
          <nuxt-link :to="`/information-${newsType}-${$get(news, 'industryId[0]', 0)}-1/`"
            :title="news.industryName + '资讯'" target="_blank" prefetch-on="interaction">
            {{ news.industryName }}
          </nuxt-link>
        </span>
        <span class="time">{{ news.publishTime || news.createTime }}</span>
        <span class="watch">
          <i class="el-icon-look"></i>
          <span>{{ news.views }}</span>
        </span>
        <div v-if="news.specialTopics" class="special-topics-box">
          <nuxt-link v-for="topic in news.specialTopics.slice(0, 3)" :key="topic.id" :to="`/special/${topic.id}.html`"
            target="_blank" prefetch-on="interaction">
            <span class="topics-item" :title="topic.specialTopicName">
              {{ topic.specialTopicName }}
            </span>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import moment from 'moment'
import _ from 'lodash'
import { handleNewsUrl } from '@/utils/common'

defineProps({
  news: {
    type: Object,
    default: () => ({
      content: ''
    })
  },
  newsType: {
    type: Number,
    default: 1
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  showType:{
    type: Boolean,
    default: false
  }
})

// filters
const formatTime = (val: string) => {
  return moment(new Date(val)).format('YYYY-MM-DD HH:mm:ss')
}

const description = (item: Record<string, any>): any => {
  if (item.description) {
    return item.description
  } else {
    const reg = /<[^>]+>/gi
    const description =
      (item.content ?? '') != ''
        ? item.content
          ?.replace(reg, '')
          ?.replace(/&nbsp;/g, '')
          .trim()
        : ''
    return description ? description?.slice(0, 100) + '...' : ''
  }
}

// methods
const $get = _.get
</script>

<style lang="less" scoped>
.news_item {
  padding: 16.5px 22px 16.5px 0;
  border-bottom: 1px dashed #d2d2d2;
  display: flex;

  &:last-child {
    border: none;
  }

  .news_img {
    width: 236px;
    height: 138px;
    border-radius: 4px;
    // border: 1px solid #ddd;
    margin-right: 22px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 236px;
      height: auto;
    }
  }

  .news_info {
    flex: 1;
    display: flex;
    flex-flow: column;
    justify-content: space-between;

    .news_title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }

    .news_abstract {
      font-size: 16px;
      line-height: 28px;
      color: #666;
      overflow: hidden;
      text-align: justify;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .news_sub {
      font-size: 16px;
      color: #999;
      display: flex;
      align-items: center;

      .industry {
        margin-right: 16px;

        a {
          font-size: 14px;
          color: @app-color;
        }
      }

      .time {
        margin-right: 25px;
      }

      .watch {
        display: flex;
        align-items: center;
        line-height: 16px;

        .el-icon-look {
          margin-right: 4px;
        }
      }

      .special-topics-box {
        margin-left: auto;

        a {
          margin-right: 4px;

          &:last-child {
            margin-right: 0;
          }
        }

        .topics-item {
          font-size: 14px;
          color: #409eff;
          border: 1px solid #d9ecff;
          border-radius: 4px;
          padding: 0 4px;
          transition: all 0.3s;
          cursor: pointer;
          display: inline-block;
          max-width: 100px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          vertical-align: middle;

          &:hover {
            color: @app-color;
            border-color: @app-color;
          }
        }
      }
    }
  }
}
</style>
